<template>
  <div class="controller-table">
    <div v-if="spotCheckState == 0">
      <el-input clearable v-model="search.patientName" style="width: 150px;margin-right: 15px;margin-bottom: 10px;"
                placeholder="请输入姓名"></el-input>
      <el-input clearable v-model="search.admitNo" style="width: 150px;margin-right: 15px;margin-bottom: 10px;"
                placeholder="请输入住院号"></el-input>
      <el-select clearable v-model="search.isHandle" placeholder="请选择修改状态"
                 style="width: 200px;margin-right: 15px;margin-bottom: 10px;">
        <el-option v-for="(item,index) in followUpStatus" :key="index" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <el-button @click="getSpotCheckList" type="primary">检索</el-button>
      <el-button @click="resetAllList">重置</el-button>
    </div>
    <!-- 全部（0） -->
    <el-table v-if="spotCheckState==0" :border="true" :data="tableData" v-loading="tableloaded">
      <el-table-column prop="userName" label="姓名" width="100"></el-table-column>
      <el-table-column prop="admitNo" label="住院号" width="100"></el-table-column>
      <el-table-column prop="completeNumber" label="完成号码" width="150"></el-table-column>
      <el-table-column label="反馈结果">
        <template slot-scope="scope">
          <div class="table-cell">
            <div v-if="scope.row.followupState =='5'">#线上问卷转电话问卷</div>
            <div>
              质控结果：{{ scope.row.secondSpotCheckState == 1 ? '合格' : '不合格' }}{{ scope.row.handleResultName ? ' | ' + scope.row.handleResultName : '' }}
            </div>
            <div>详情描述：{{ scope.row.firstSpotCheckStateStrText }}；
              <div class="table-cell-detail"><span v-html="scope.row.spotCheckRemarks"></span></div>
            </div>
            <div v-if="scope.row.manageCheckRemarks">追加质控：{{ scope.row.manageCheckRemarks }}</div>
            <div>质控得分：{{ scope.row.qualityScore ? scope.row.qualityScore : '无' }}</div>
            <div>质控时间：{{ scope.row.spotCheckTime }}</div>
            <div v-if="scope.row.numberOfErrors">错题数：{{ scope.row.numberOfErrors }}</div>
            <div>
              <span v-if="scope.row.problemRecordsResult.length>0"> 批注详情：</span>
              <div v-for="(it,ind) in scope.row.problemRecordsResult" :key="ind">
                <span v-if="it.isRight">{{ it.serialNumber }}. {{ it.remark }}</span>
                <span v-else style="color: red;">{{ it.serialNumber }}. {{ it.remark }}</span>
              </div>
            </div>

          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="拨打时间" width="180">
        <template slot-scope="scope">
          <span v-html="scope.row.callTime"></span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 需重拨（1） -->
    <el-table v-if="spotCheckState==1" :border="true" :data="tableData" v-loading="tableloaded">
      <el-table-column prop="userName" label="姓名" width="100"></el-table-column>
      <el-table-column prop="admitNo" label="住院号" width="100"></el-table-column>
      <el-table-column prop="completeNumber" label="完成号码" width="100"></el-table-column>
      <el-table-column label="反馈结果">
        <template slot-scope="scope">
          <!-- <div class="result-cell" v-html="scope.row.qualityControlResult"></div> -->
          <div>
            <div v-if="scope.row.followupState =='5'">#线上问卷转电话问卷</div>
            <div>
              质控结果：{{ scope.row.secondSpotCheckState == 1 ? '合格' : '不合格' }}{{ scope.row.handleResultName ? ' | ' + scope.row.handleResultName : '' }}
            </div>
            <div>详情描述：{{ scope.row.firstSpotCheckStateStrText }}；
              <div class="table-cell-detail"><span v-html="scope.row.spotCheckRemarks"></span></div>
            </div>
            <div v-if="scope.row.manageCheckRemarks">追加质控：{{ scope.row.manageCheckRemarks }}</div>
            <div>质控得分：{{ scope.row.qualityScore ? scope.row.qualityScore : '无' }}</div>
            <div>质控时间：{{ scope.row.spotCheckTime }}</div>
            <div v-if="scope.row.numberOfErrors">错题数：{{ scope.row.numberOfErrors }}</div>
            <div>
              <span v-if="scope.row.problemRecordsResult.length>0"> 批注详情：</span>
              <div v-for="(it,ind) in scope.row.problemRecordsResult" :key="ind">
                <span v-if="it.isRight">{{ it.serialNumber }}. {{ it.remark }}</span>
                <span v-else style="color: red;">{{ it.serialNumber }}. {{ it.remark }}</span>
              </div>
            </div>

          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="拨打时间" width="150">
        <template slot-scope="scope">
          <span v-html="scope.row.callTime"></span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <div v-if="!scope.row.isOtherSeatReply">
            <span v-if="scope.row.qualityResultDynamic ==5 || scope.row.qualityResultDynamic == 6"
                  style="color:#949090;">已重拨</span>
            <el-button type="text" v-else @click="reCall(scope.row,'1')">重拨</el-button>
          </div>
          <el-button v-else type="text" v-else @click="gotoDetail(scope.row,'1')">查看详情</el-button>

        </template>
      </el-table-column>
    </el-table>
    <!-- 需修改（4） -->
    <el-table v-if="spotCheckState==4" :border="true" :data="tableData" v-loading="tableloaded">
      <el-table-column prop="userName" label="姓名" width="100"></el-table-column>
      <el-table-column prop="admitNo" label="住院号" width="100"></el-table-column>
      <el-table-column prop="completeNumber" label="完成号码" width="100"></el-table-column>
      <el-table-column label="反馈结果">
        <template slot-scope="scope">
          <!-- <div class="result-cell" v-html="scope.row.qualityControlResult"></div> -->
          <div>
            <div v-if="scope.row.followupState =='5'">#线上问卷转电话问卷</div>
            <div>
              质控结果：{{ scope.row.secondSpotCheckState == 1 ? '合格' : '不合格' }}{{ scope.row.handleResultName ? ' | ' + scope.row.handleResultName : '' }}
            </div>
            <div>详情描述：{{ scope.row.firstSpotCheckStateStrText }}；
              <div class="table-cell-detail"><span v-html="scope.row.spotCheckRemarks"></span></div>
            </div>
            <div v-if="scope.row.manageCheckRemarks">追加质控：{{ scope.row.manageCheckRemarks }}</div>
            <div>质控得分：{{ scope.row.qualityScore ? scope.row.qualityScore : '无' }}</div>
            <div>质控时间：{{ scope.row.spotCheckTime }}</div>
            <div v-if="scope.row.numberOfErrors">错题数：{{ scope.row.numberOfErrors }}</div>
            <div>
              <span v-if="scope.row.problemRecordsResult.length>0"> 批注详情：</span>
              <div v-for="(it,ind) in scope.row.problemRecordsResult" :key="ind">
                <span v-if="it.isRight">{{ it.serialNumber }}. {{ it.remark }}</span>
                <span v-else style="color: red;">{{ it.serialNumber }}. {{ it.remark }}</span>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="拨打时间" width="150">
        <template slot-scope="scope">
          <span v-html="scope.row.callTime"></span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.qualityResultDynamic == 5||scope.row.qualityResultDynamic == 6" style="color:#949090;">修改</span>
          <el-button type="text" v-else @click="reCall(scope.row,'4')">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 需注意（2） -->
    <el-table v-if="spotCheckState==2" :border="true" :data="tableData" v-loading="tableloaded">
      <el-table-column prop="userName" label="姓名" width="100"></el-table-column>
      <el-table-column prop="admitNo" label="住院号" width="100"></el-table-column>
      <el-table-column prop="completeNumber" label="完成号码" width="100"></el-table-column>
      <el-table-column label="反馈结果">
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.followupState =='5'">#线上问卷转电话问卷</div>
            <div>
              质控结果：{{ scope.row.secondSpotCheckState == 1 ? '合格' : '不合格' }}{{ scope.row.handleResultName ? ' | ' + scope.row.handleResultName : '' }}
            </div>
            <div>详情描述：{{ scope.row.firstSpotCheckStateStrText }}；
              <div class="table-cell-detail"><span v-html="scope.row.spotCheckRemarks"></span></div>
            </div>
            <div v-if="scope.row.manageCheckRemarks">追加质控：{{ scope.row.manageCheckRemarks }}</div>
            <div>质控得分：{{ scope.row.qualityScore ? scope.row.qualityScore : '无' }}</div>
            <div>质控时间：{{ scope.row.spotCheckTime }}</div>
            <div v-if="scope.row.numberOfErrors">错题数：{{ scope.row.numberOfErrors }}</div>
            <div>
              <span v-if="scope.row.problemRecordsResult.length>0"> 批注详情：</span>
              <div v-for="(it,ind) in scope.row.problemRecordsResult" :key="ind">
                <span v-if="it.isRight">{{ it.serialNumber }}. {{ it.remark }}</span>
                <span v-else style="color: red;">{{ it.serialNumber }}. {{ it.remark }}</span>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="拨打时间" width="150">
        <template slot-scope="scope">
          <span v-html="scope.row.callTime"></span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <div class="red-bot" v-if="scope.row.qualityResultDynamic==3"></div>
          <el-button type="text" is-dot @click="goFeedbackDetail(scope.row)">查看反馈</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--    复杂重拨5-->
    <el-table v-if="spotCheckState==5" :border="true" :data="tableData" v-loading="tableloaded">
      <el-table-column prop="userName" label="姓名" width="100"></el-table-column>
      <el-table-column prop="admitNo" label="住院号" width="100"></el-table-column>
      <el-table-column prop="completeNumber" label="完成号码" width="100"></el-table-column>
      <el-table-column label="反馈结果">
        <template slot-scope="scope">
          <!-- <div class="result-cell" v-html="scope.row.qualityControlResult"></div> -->
          <div>
            <div v-if="scope.row.followupState =='5'">#线上问卷转电话问卷</div>
            <div>
              质控结果：{{ scope.row.secondSpotCheckState == 1 ? '合格' : '不合格' }}{{ scope.row.handleResultName ? ' | ' + scope.row.handleResultName : '' }}
            </div>
            <div>详情描述：{{ scope.row.firstSpotCheckStateStrText }}；
              <div class="table-cell-detail"><span v-html="scope.row.spotCheckRemarks"></span></div>
            </div>
            <div v-if="scope.row.manageCheckRemarks">追加质控：{{ scope.row.manageCheckRemarks }}</div>
            <div>质控得分：{{ scope.row.qualityScore ? scope.row.qualityScore : '无' }}</div>
            <div>质控时间：{{ scope.row.spotCheckTime }}</div>
            <div v-if="scope.row.numberOfErrors">错题数：{{ scope.row.numberOfErrors }}</div>
            <div>
              <span v-if="scope.row.problemRecordsResult.length>0"> 批注详情：</span>
              <div v-for="(it,ind) in scope.row.problemRecordsResult" :key="ind">
                <span v-if="it.isRight">{{ it.serialNumber }}. {{ it.remark }}</span>
                <span v-else style="color: red;">{{ it.serialNumber }}. {{ it.remark }}</span>
              </div>
            </div>

          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="拨打时间" width="150">
        <template slot-scope="scope">
          <span v-html="scope.row.callTime"></span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
            <span v-if="scope.row.qualityResultDynamic ==5 || scope.row.qualityResultDynamic == 6"
                  style="color:#949090;">已重拨</span>
            <el-button type="text" v-else @click="reCall(scope.row,'1')">重拨</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top:10px;">
      <el-pagination
          background
          layout=" prev, pager, next"
          :page-count="totalPage"
          @current-change="currentChange"
          :current-page="currentPage"
      ></el-pagination>
    </div>

    <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="30%"
    >
      <div class="dialog-content">
        <div style="font-weight:bold;">质控时间：{{ feedbackDetailData.spotCheckTime }}</div>
        <div>质控结果：{{ feedbackDetailData.secondSpotCheckState == 1 ? '合格' : '不合格' }} |
          {{ feedbackDetailData.handleResultName }}
        </div>
        <div>详情描述：{{ feedbackDetailData.firstSpotCheckStateStrText }}；{{ feedbackDetailData.spotCheckRemarks }}
        </div>
        <div v-if="feedbackDetailData.manageCheckRemarks">追加质控：{{ feedbackDetailData.manageCheckRemarks }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import {
  RestNewFollowupCallCenterServiceGetFollowUpTaskSpotCheckList, //获取抽查列表
  RestNewFollowupCallCenterServiceUpdateQualityResultDynamicById
} from "@src/assets/js/api.js";
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "ControllerTable",
  props: ["spotCheckState"],
  data() {
    return {
      followUpStatus: [
        {label: '已处理', value: 1},
        {label: '未处理', value: 0},
      ],
      search: {
        patientName: null,
        admitNo: null,
        isHandle: null,
      },
      tableloaded: false,
      pageIndex: 1,
      totalPage: 1,
      currentPage: 1,
      tableData: [],
      dialogVisible: false,
      feedbackDetailData: {},  //需注意---质控反馈
    };
  },
  computed: {
    ...mapGetters(["userid", "getTaskCenterId"])
  },
  watch: {
    spotCheckState: {
      handler(val) {
        this.currentPage = 1;
        this.spotCheckState = val
        this.getSpotCheckList();
      }
    }
  },
  mounted() {
    let vm = this;
    vm.getSpotCheckList();
  },
  methods: {
    ...mapMutations(["setTaskCenterId", "setTaskTitle", "setQuestion"]),

    gotoDetail(item) {
      console.log(item);
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId',
            params: {
              followupTaskId: this.getTaskCenterId
            }
          }
      ).then(res => {
        this.setQuestion(res.retValue)
        this.setTaskCenterId(this.getTaskCenterId)
        this.$router.push({
          path: `/wrongQuestionDetail?followUpPatientInfoId=${item.followUpPatientInfoId}`,
        })
      })

    },
    resetAllList() {
      this.search.admitNo = ""
      this.search.patientName = ""
      this.search.isHandle = ""
      this.getSpotCheckList()
    },
    reCall(params, type) {
      this.$emit('aliyunLogin', () => {
        this.$router.push({
          path: "/callPatient",
          query: {
            abnormal: 5,
            followUpPatientInfoId: params.followUpPatientInfoId,
            followupPatientId: params.followupPatientId,
            diseaseId: this.$route.query.diseaseId,
            followupSource: 2,
            isRemindStudy: this.$route.query.isRemindStudy,
            isSingleDuration: this.$route.query.isSingleDuration,
            isTotalDuration: this.$route.query.isTotalDuration,
            spotCheckId: type != '2' ? params.spotCheckId : null,
            type: type, // 1:需重拨   4：需修改
          }
        });
      })

    },
    goFeedbackDetail(params) {
      // 需注意--查看反馈
      // 已读未读
      let data = {
        spotCheckId: [params.spotCheckId],
        userId: this.userid,
        userType: 2,  //内部（管理台）0  外部1   呼叫中心2
        qualityResultDynamic: 6,
        followUpPatientInfoId: [params.followUpPatientInfoId],
      }
      this.updateQualityResultDynamicAsync(data).then(res => {
        if (res.status == 0) {
          this.$router.push({
            path: "/callPatient",
            query: {
              abnormal: 5,
              followUpPatientInfoId: params.followUpPatientInfoId,
              followupPatientId: params.followupPatientId,
              diseaseId: this.$route.query.diseaseId,
              followupSource: 2,
              isRemindStudy: this.$route.query.isRemindStudy,
              isSingleDuration: this.$route.query.isSingleDuration,
              isTotalDuration: this.$route.query.isTotalDuration,
              spotCheckId: params.spotCheckId || null,
              aliLogin: true,
              type: 2, //需注意
            }
          });
        }
      })
    },
    currentChange(page) {
      this.currentPage = page;
      this.getSpotCheckList();
    },
    getSpotCheckList() {
      this.tableloaded = true;
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        handleResult: this.spotCheckState == 0 ? null : this.spotCheckState,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        isHandle: this.search.isHandle,
        patientName: this.search.patientName,
        admitNo: this.search.admitNo,
      };
      this.tableData = [];
      if (this.spotCheckState == 5) {
        this.getFollowUpTaskComplexReplayList({
          seatId: sessionStorage.getItem('userid'),
          followUpTaskId: params.followupTaskId,
          pageIndex: params.currentPage,
          pageSize: params.pageSize,
        }).then(res => {
          this.tableData = res.retValue.map(item => {
            item.manageCheckRemarks = item.manageCheckRemarks.replace(/<\/?.+?\/?>/g, '')
            // item.spotCheckRemarks =  item.spotCheckRemarks.replace(/<\/?.+?\/?>/g,'')
            item.handleResultName = this.getHandleresult(item.handleResult)
            let stateArr = item.firstSpotCheckState.substr(1, item.firstSpotCheckState.length - 2).split(',');
            stateArr = stateArr.map(it => {
              return this.getSpotCheckState(it)
            })
            item.firstSpotCheckStateStrText = stateArr.join(',')
            // 批注问题
            item.problemRecordsResult = []
            if (item.problemRecords) {
              item.problemRecordsResult = item.problemRecords.filter(it => it.remark != '')
            }
            return item
          })

          this.totalPage = res.totalPage;
          this.currentPage = res.page;
          this.tableloaded = false;
        })
      }else {
        this.getTaskSpotCheckListAsync(params).then(res => {
          this.tableData = res.retValue.map(item => {
            item.manageCheckRemarks = item.manageCheckRemarks.replace(/<\/?.+?\/?>/g, '')
            // item.spotCheckRemarks =  item.spotCheckRemarks.replace(/<\/?.+?\/?>/g,'')
            item.handleResultName = this.getHandleresult(item.handleResult)
            let stateArr = item.firstSpotCheckState.substr(1, item.firstSpotCheckState.length - 2).split(',');
            stateArr = stateArr.map(it => {
              return this.getSpotCheckState(it)
            })
            item.firstSpotCheckStateStrText = stateArr.join(',')
            // 批注问题
            item.problemRecordsResult = []
            if (item.problemRecords) {
              item.problemRecordsResult = item.problemRecords.filter(it => it.remark != '')
            }
            return item
          })

          this.totalPage = res.totalPage;
          this.currentPage = res.page;
          this.tableloaded = false;
        });
      }

    },

    getHandleresult(state) {
      switch (state) {
        case 1:
          return '需重拨'
          break
        case 2:
          return '需注意'
          break
        case 3:
          return '平台相关'
          break
        case 4:
          return '需修改问卷'
          break
      }
    },
    getSpotCheckState(state) {
      switch (state) {
        case '8':
          return '收集不足';
          break
        case '9':
          return '态度欠佳';
          break
        case '10':
          return '录音缺失';
          break
        case '11':
          return '记录有误';
          break
        case '15':
          return '逻辑清晰';
          break
        case '16':
          return '收集完整';
          break
        case '17':
          return '态度良好';
          break
        case '18':
          return '记录准确';
          break

        case '21':
          return '混乱无序';
          break
        case '22':
          return '清楚流利';
          break
        case '23':
          return '生疏含混';
          break
        case '24':
          return '积极灵活';
          break
        case '25':
          return '刻板迟钝';
          break
      }
    },
    async getFollowUpTaskComplexReplayList(p) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetFollowUpTaskComplexReplayList',
        params: {
          seatId: p.seatId,
          followUpTaskId: p.followUpTaskId,
          pageIndex: p.pageIndex,
          pageSize: p.pageSize,
        }
      })
      return result
    },
    // 需重拨（1）、需注意（2）、需修改（4）
    async getTaskSpotCheckListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetFollowUpTaskSpotCheckList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_secondSpotCheckState = p.secondSpotCheckState;
      request.p_handleResult = p.handleResult;
      request.p_admitNo = p.admitNo;
      request.p_patientName = p.patientName;
      request.p_isHandle = p.isHandle;
      request.p_pageIndex = p.currentPage;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    async updateQualityResultDynamicAsync(p) {
      let request = new RestNewFollowupCallCenterServiceUpdateQualityResultDynamicById();
      request.p_spotCheckId = p.spotCheckId
      request.p_userId = p.userId
      request.p_userType = p.userType;
      request.p_qualityResultDynamic = p.qualityResultDynamic
      request.p_followUpPatientInfoId = p.followUpPatientInfoId
      await request.send();
      return request.result;
    },
  }
};
</script>

<style scoped lang="scss">
.result-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dialog-content {
  font-size: 16px;
  padding: 0px 30px;
  line-height: 30px;
  color: #000;
}

.red-bot {
  background-color: red;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  display: inline-block;
  margin-right: 3px;
}

</style>
<style lang="scss">
.controller-table .table-cell {
  &-detail {
    p {
      word-break: break-all;
      word-wrap: break-word;
    }

    ul {
      padding: 0 1em;
      list-style-type: disc !important;
      list-style-position: inside !important;
    }

    ol {
      padding: 0 1em;
      list-style-type: decimal !important;
      list-style-position: inside !important;
    }

    li {
      white-space: normal;
      word-break: break-all;
      word-wrap: break-word;
    }
  }
}
</style>
